// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SA2Xr","label":"styles_label__1bPjX"};